/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/A3/components/A3CarbonSummary.tsx.
 */

import React from "react";
import { EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL } from "../../shared/contributorFieldDisplayLabels";

interface Props {
  /** Cumulative embodied carbon from all fuel rows (kg CO₂eq). */
  totalEmbodiedCarbonKg?: number;
  /** Cumulative ÷ background finished material declared qty. */
  perDeclaredFinishedKg?: number | null;
  /** Unit for per-finished qty (from Background finished material unit). */
  perFinishedUnitLabel?: string;
}

const A3CarbonSummary: React.FC<Props> = ({
  totalEmbodiedCarbonKg = 0,
  perDeclaredFinishedKg,
  perFinishedUnitLabel = "kg CO₂e per finished qty",
}) => {
  const total = Number(totalEmbodiedCarbonKg) || 0;

  return (
    <div className="embodied-carbon-summary-container a3-derived-carbon-summary">
      <div className="ecs-row">
        <div className="ecs-col ecs-col-left">
          <label className="ecs-label">
            Cumulative embodied carbon (all fuels, A3)
          </label>
          <input readOnly value={String(total)} className="ecs-input" />
        </div>
        <div className="ecs-col ecs-col-right">
          <label className="ecs-label">Unit</label>
          <input readOnly value="kg CO₂e" className="ecs-input" />
        </div>
      </div>
      {perDeclaredFinishedKg != null &&
      Number.isFinite(perDeclaredFinishedKg) ? (
        <div className="ecs-row ecs-row-secondary">
          <div className="ecs-col ecs-col-left">
            <label className="ecs-label">
              {EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL}
            </label>
            <input
              readOnly
              value={String(perDeclaredFinishedKg)}
              className="ecs-input"
            />
          </div>
          <div className="ecs-col ecs-col-right">
            <label className="ecs-label">Unit</label>
            <input
              readOnly
              value={perFinishedUnitLabel}
              className="ecs-input"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

/** React component — A3Carbon Summary. */
export default A3CarbonSummary;
